/**
 * DateRangeToggle — Radix ToggleGroup pill for the 6 BI date-range enum values.
 *
 * Phase 16 / Task 16.6 (DEC-163). Fires onRangeChange with the new value on
 * user click; controlled component.
 */
import React from 'react';
import { ToggleGroup, ToggleGroupItem } from 'src/components/ui/toggle-group';
import type { BiDateRange } from '@lodex-pro/shared/validation/disposal-bi-panels';
import { BI_DATE_RANGES } from '@lodex-pro/shared/validation/disposal-bi-panels';

interface DateRangeToggleProps {
  readonly value: BiDateRange;
  readonly onRangeChange: (range: BiDateRange) => void;
}

export function DateRangeToggle({ value, onRangeChange }: DateRangeToggleProps): React.JSX.Element {
  return (
    <ToggleGroup
      type="single"
      value={value}
      onValueChange={(v) => {
        // Radix returns '' when the current item is toggled off; ignore.
        if (v === '') return;
        onRangeChange(v as BiDateRange);
      }}
      variant="outline"
      size="sm"
      aria-label="Date range"
    >
      {BI_DATE_RANGES.map((range) => (
        <ToggleGroupItem
          key={range}
          value={range}
          aria-label={`Set date range to ${range}`}
          className="border-input bg-transparent text-[var(--color-text-tertiary)] hover:text-foreground data-[state=on]:bg-primary data-[state=on]:text-primary-foreground"
        >
          {range}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  );
}
